module.exports = __webpack_public_path__ + "img/pic36.84b35594.png";